export default "/images/4ed7c1d474d30b6878f5c0273caac9ab.avif";